<ng-template [ngIf]="riunioneGiudiziForm ">
<div class="col-sm-12 coldx">
	<h4 *ngIf="title">{{title}}</h4>
	
	<div class="tab-content">
		<form [formGroup]="riunioneGiudiziForm" (ngSubmit)="save();">
			<div class="row">
				<div datePickerInput  class="col-sm-12" [labelInput]="'Data riunione'" [mandatory]="true"
					formControlName="dataRiunione" [(ngModel)]="request.dataRiunione"
					[mandatory]="true"></div>
			</div>
			<div class="row">
				<div textAreaInput class="col-sm-12" [labelInput]="'Motivo riunione'" [mandatory]="true"
					formControlName="motivoRiunione" [(ngModel)]="request.motivoRiunione"></div>
			</div>
			<div class="row">
				<p class="mandatory col-sm-12">
					<em>* Campi obbligatori</em>
				</p>
			</div>
			<div class="row">
				<p class="col-sm-3 col-xs-6">
					<button type="button" class="btn btn-outline-secondary btn-block">Reset</button>
				</p>
				<p submitButton [disabled]="!riunioneGiudiziForm.valid"
					class="col-sm-3 col-xs-6 col-sm-offset-6"
					[labelButton]="'Salva'"></p>
			</div>
		</form>
	</div>
</div>
</ng-template>